import { render } from "./Edit.vue?vue&type=template&id=35c42a68&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=35c42a68&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c42a68"],['__file',"src/views/Suppliers/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35c42a68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35c42a68', __exports__)) {
    api.reload('35c42a68', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=35c42a68&scoped=true", () => {
    api.rerender('35c42a68', render)
  })

}


export default __exports__